import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { read, WorkBook, utils, WorkSheet } from 'xlsx';
import { ImportFromCsvService } from './import-from-csv.service';

@Injectable({
  providedIn: 'root',
})
export class ImportFromXlsxService {
  constructor(private importFromCsv: ImportFromCsvService) {}

  public parseXLSX(target, type?: 'loadingSpaces' | 'loads' | 'users') {
    return new Observable((observable) => {
      const reader: FileReader = new FileReader();
      reader.onload = (e) => {
        const workBook: WorkBook = read(e.target.result);
        const workSheetName: string = workBook.SheetNames[0];
        const workSheet: WorkSheet = workBook.Sheets[workSheetName];
        const sheet = utils.sheet_to_json(workSheet, { header: 1, defval: '', blankrows: false });
        try {
          let data;
          if (type === 'loadingSpaces') {
            data = this.importFromCsv.parseLoadingSpacesObjects(sheet);
          } else if (type === 'loads') {
            data = this.importFromCsv.parseLoadsObjects(sheet);
          } else if (type === 'users') {
            data = this.importFromCsv.parseUsersObjects(sheet);
          } else {
            data = this.importFromCsv.parseObjects(sheet);
          }
          observable.next(data);
          observable.complete();
        } catch (error) {
          observable.error(error);
        }
      };
      reader.readAsArrayBuffer(target);
    });
  }
}
